import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'next/router';

import { listProSignUpSelector } from 'modules/job-types/duck';
import { geoLocationSelector } from 'modules/locations/duck';
import type { Location } from 'modules/locations/types';
import { getCurrentUser, getIsLoadingAuth } from 'modules/users/duck';
import type { RootState } from 'store/types';

import ProForm, { Props } from './ProForm';

const mapStateToProps = (state: RootState) => ({
  jobTypes: listProSignUpSelector(state),
  location: geoLocationSelector(state) as Location | undefined,
  currentUser: getCurrentUser(state),
  isLoadingAuth: getIsLoadingAuth(state) as boolean,
});

export type ReduxProps = ReturnType<typeof mapStateToProps>;

export default compose(
  connect(mapStateToProps),
  withTranslation(),
  withRouter
)(ProForm) as React.ComponentType<Partial<Props>>;
